export default __webpack_public_path__ + "static/media/dep2_8.832928a8.png";